import { useMutation } from '@apollo/client'
import { ApproveTestSession, ApproveTestSessionVariables } from '../../types'
import { REJECT_TEST_SESSION } from './operations'

export const useRejectTestSession = () =>
  useMutation<ApproveTestSession, ApproveTestSessionVariables>(REJECT_TEST_SESSION)
